import { forwardRef, useState, useCallback, ReactNode } from 'react';
import { IconButton, Box, Button } from '@material-ui/core';
import { CustomContentProps, useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';

import { StyledMaterialDesignContent } from './StyledMaterialDesignContent';
import { DetailsDialog } from './DetailsDialog';

interface CustomSnackbarContentProps extends CustomContentProps {
  details?: object | string;
  hideCloseButton?: boolean;
}

export const CustomSnackbarContent = forwardRef<
  HTMLDivElement,
  CustomSnackbarContentProps
>((props, ref) => {
  const { closeSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const { details, hideCloseButton } = props;

  const handleOpenDetails = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    closeSnackbar(props.id);
  }, [closeSnackbar, props.id]);

  const externalAction =
    typeof props.action === 'function'
      ? props.action(props.id)
      : (props.action as ReactNode | undefined);

  const resolvedAction =
    externalAction ??
    (details ? (
      <Button
        variant="text"
        size="small"
        style={{
          color: '#fff',
          borderColor: '#fff',
          borderRadius: 120,
          textTransform: 'none'
        }}
        onClick={handleOpenDetails}>
        Details
      </Button>
    ) : undefined);

  return (
    <>
      <Box position="relative" display="inline-flex" alignItems="center">
        <StyledMaterialDesignContent
          ref={ref}
          {...props}
          action={resolvedAction}
        />

        {!hideCloseButton && (
          <IconButton
            size="small"
            style={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)'
            }}
            onClick={() => closeSnackbar(props.id)}>
            <CloseIcon style={{ color: '#fff', fontSize: 20 }} />
          </IconButton>
        )}
      </Box>
      <DetailsDialog open={open} onClose={handleClose} details={details} />
    </>
  );
});
